import { AfterViewInit, Component, Inject, Input, EventEmitter, Output } from '@angular/core';

import { ParcService } from '../services/parc.service';
import { ParcTLR } from '../entities/parc-tlr.entity';

@Component({
	selector: 'parc-selector',
	templateUrl: 'parc-selector.html',
	styleUrls: ['parc-selector.css']
})
export class ParcSelectorComponent implements AfterViewInit {
	@Input() id!: string;
	@Input() disabled = false;

	// Parametres de style
	public _mandatory: boolean = false;
	@Input() set mandatory(value: boolean | undefined) {
		if (value) {
			this._mandatory = value;
		}
	}
	get mandatory(): boolean | undefined {
		return this._mandatory;
	}
	public _labelClass = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	public _fieldClass = 'col-md-3';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}

	private _antenneId: number | null = null;
	@Input() set antenneId(value: number | null) {
		this._antenneId = value;

		if (value) {
			// RG5 & RG9 & RG12 : Si l'antenne est sélectionnée alors les parcs proposés dans la liste sont fonction de l'antenne
			this.parcService.getParcTLRByAntenne(value).subscribe(
				(parcs: ParcTLR[]) => {
					if (this._antenneId) {
						this.availableParcs = parcs;
						this.checkSelectedParcValidity();
					}
				}
			);
		} else {
			this.parcService.getParcTLRList().subscribe(
				(result: ParcTLR[]) => {
					if (!this._antenneId) {
						this.availableParcs = result;
						// NB: Inutile de verifier la validite du parc selectionne, puisque tous les parcs sont disponibles quand il n'y a pas d'antenne precisee
					}
				}
			);
		}
	}
	get antenneId(): number | null {
		return this._antenneId;
	}

	@Input() set selectedParcId(id: number | undefined) {
		let currentId = this.selectedParc ? this.selectedParc.id : undefined;
		if (currentId != id) {
			if (id) {
				this.parcService.getParcTLRById(id).subscribe(
					(parc: ParcTLR) => {
						this.selectedParc = parc;
						this.onParcChange();
					}
				);
			} else {
				this.selectedParc = undefined;
				this.onParcChange();
			}
		}
	}
	get selectedParcId(): number | undefined {
		return this.selectedParc ? this.selectedParc.id : undefined;
	}
	@Output() selectedParcIdChange = new EventEmitter<number | undefined>();

	selectedParc: ParcTLR | undefined = undefined;
	@Output() selectedParcChange = new EventEmitter<ParcTLR | undefined>();
	
	// Evenements supplementaires decrivant une selection manuelle du parc par l'utilisateur
	@Output() parcIdSelected = new EventEmitter<number | undefined>();
	@Output() parcSelected = new EventEmitter<ParcTLR | undefined>();

	// RG11 : Les parcs sont filtrés selon leur trigramme ou leur nom
	getParcName = (parc: ParcTLR) => parc.code + ' (' + (parc.description ? parc.description : '') + ')';

	availableParcs!: ParcTLR[];

	constructor( //
		@Inject(ParcService) private parcService: ParcService //
	) {
		// Charger l'ensemble des parcs comme etant la liste des parcs disponibles par defaut
		// (Ceci est necessaire au cas ou l'input 'antenneId' ne serait pas bind)
		this.parcService.getParcTLRList().subscribe(
			(result: ParcTLR[]) => {
				// Verifier quand meme que la valeur de l'antenne n'a pas change avant de fixer la liste 
				if (!this._antenneId) {
					this.availableParcs = result;
				}
			}
		);
	}

	ngAfterViewInit() {
	}
	
	// Reaction au fait que l'utilisateur selectionne une valeur manuellement dans le composant
	onParcSelected() {
		const parc = this.selectedParc;
		if (parc) {
			this.parcIdSelected.emit(parc.id);
			this.parcSelected.emit(parc);
		} else {
			this.parcIdSelected.emit(undefined);
			this.parcSelected.emit(undefined);
		}
	}

	// Reaction au fait que le parc selectionne change (que ce soit par action de l'utilisateur ou programmativement)
	onParcChange() {
		const parc = this.selectedParc;
		if (parc) {
			this.selectedParcIdChange.emit(parc.id);
			this.selectedParcChange.emit(parc);
		} else {
			this.selectedParcIdChange.emit(undefined);
			this.selectedParcChange.emit(undefined);
		}
	}

	// Fonction verifiant que le parc actuellement selectionne est bien toujours dans la liste des parcs proposes 
	private checkSelectedParcValidity() {
		if (this.selectedParc) {
			const parcId = this.selectedParc.id;
			const parcIsStillAvailable = this.availableParcs.filter(
				(parc) => parc.id === parcId
			).length > 0;
			if (!parcIsStillAvailable) {
				this.selectedParcId = undefined;
				this.selectedParcIdChange.emit(undefined);
			}
		}
	}
}